import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {FormsModule, type NgForm, ReactiveFormsModule} from '@angular/forms';
import {ErrorService} from '@dv/kitadmin/core/errors';
import {DatepickerTextfieldComponent, handleResponse, LoadingButtonComponent} from '@dv/shared/angular';
import {DemoDataApi} from '@dv/shared/backend/api/demo-data.api';
import {JaxSchulungsMandantInformation} from '@dv/shared/backend/model/jax-schulungs-mandant-information';
import {DvbDateUtil, DvbRestUtil} from '@dv/shared/code';
import {TranslocoDirective} from '@jsverse/transloco';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {tap} from 'rxjs';

const DEFAULT_ANGESTELLTE_COUNT = 500;

@Component({
    selector: 'dv-maintenance-work-time-demodata',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        TranslocoDirective,
        DatepickerTextfieldComponent,
        LoadingButtonComponent,
        TooltipModule,

    ],
    templateUrl: './maintenance-work-time-demodata.component.html',
    styles: `
        :host {
            display: block;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenanceWorkTimeDemodataComponent {

    public isLoading = signal(false);
    public gueltigAb = DvbDateUtil.today().startOf('month');
    public gueltigBis = DvbDateUtil.today().endOf('month');
    public angestellteCount = DEFAULT_ANGESTELLTE_COUNT;

    public result?: JaxSchulungsMandantInformation;

    private demoDataApi = inject(DemoDataApi);
    private errorService = inject(ErrorService);

    public submit(form: NgForm): void {
        const isValid = !!form.valid;
        this.errorService.handleValidationError(isValid, 'ERRORS.ERR_INCOMPLETE_FORM');
        if (!isValid) {
            return;
        }

        this.isLoading.set(true);
        this.result = undefined;
        this.demoDataApi.workTimeControlling$({
                workTimeControlling: {
                    gueltigAb: DvbRestUtil.momentToLocalDateChecked(this.gueltigAb),
                    gueltigBis: DvbRestUtil.momentToLocalDateChecked(this.gueltigBis),
                    angestellteCount: this.angestellteCount,
                },
            },
        ).pipe(tap(x => console.log(x)), handleResponse({
            next: response => {
                this.result = response;
            },
            finalize: () => {
                this.isLoading.set(false);
            },
        })).subscribe();
    }
}
